import React, { useState, useEffect } from 'react';
import PropTypes 					  from 'prop-types';
import ReloadHelper 				  from '../utils/ReloadHelper';
import Flux 					      from '../flux/Flux';
import { generateKey }				  from '../utils/CommonUtils';

const Breadcrumb = (props) => {

	const { breadcrumbType, breadcrumbKey, breadcrumbData, classModifier } = props;

	const [breadcrumbList, setBreadcrumbList] = useState([]);

	useEffect(() => {
		const updateBreadcrumb = (newKey) => {
			const newBreadcrumbList = Flux.Breadcrumb.getBreadcrumb(newKey);
			if (newBreadcrumbList) {
				setBreadcrumbList(newBreadcrumbList);
			}
		};

		if (!Flux.Breadcrumb.getBreadcrumb(breadcrumbKey) || breadcrumbData?.albumId) {
			Flux.Breadcrumb.loadBreadcrumb(breadcrumbType, breadcrumbData, breadcrumbKey);
		} else {
			updateBreadcrumb(breadcrumbKey);
		}

		const onBreadcrumbChange = (newType, newKey) => {
			updateBreadcrumb(newKey);
		};

		Flux.Breadcrumb.addBreadcrumbChangeListener(onBreadcrumbChange);
		return () => {
			Flux.Breadcrumb.removeBreadcrumbChangeListener(onBreadcrumbChange);
		};
	}, [breadcrumbType, JSON.stringify(breadcrumbData), breadcrumbKey]);


	const onLinkClick = (e, targetUrl) => {
		if(props.navigateTo && targetUrl.includes(props.profilePath)){
			props.navigateTo(targetUrl, e);
		} else {
			ReloadHelper.reload(targetUrl, e);
		}
	};

	const content = breadcrumbList.map((val, idx) => {
		const onClickFunc = (e) => { onLinkClick(e, val.url); };
		const link = (
			<a
				href					= {val.url}
				onMouseDown				= {onClickFunc}
				className				= "breadcrumb__link"
				title					= {val.name}
				dangerouslySetInnerHTML = {{__html: ['Person', 'H1'].includes(val.type) ? `<h1>${val.name}</h1>` : `${val.name}`}}
			/>
		);
		return (
			<li
				key       = {generateKey('breadcrumb', idx)}
				className = "breadcrumb__item"
			>
				{idx !== 0 && <li><span className="breadcrumb__separator">&raquo;</span></li>}
				<li>{val.url ? link : val.name}</li>
			</li>
		);
	});

	return (
		<ol ref={props.breadcrumbRef} className={`breadcrumb ${classModifier}`}>
			{content}
		</ol>
	);
};

Breadcrumb.propTypes = {
	breadcrumbType: PropTypes.string.isRequired,
	breadcrumbKey:  PropTypes.string,
	breadcrumbData: PropTypes.object,
	breadcrumbRef:  PropTypes.object,
	classModifier:  PropTypes.string,
	navigateTo:	    PropTypes.func,
	profilePath:    PropTypes.string,
};

Breadcrumb.defaultProps = {
	classModifier: '',
};

export default Breadcrumb;
